import React, { useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import MyMap from "../Maps/MyMap";
import Clusters from "../Maps/Clusters";
import { AbsoluteLoadingIndicator } from "../Common/FullScreenLoadingIndicator";

export default function MapAssetsSlider({
  item,
  label = "Map",
  isEventLocations = false,
}) {
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loading, setLoading] = useState(false);
  const filters = {
    Assets: true,
    Events: isEventLocations,
    Contacts: false,
    AssetUuids: [],
    EventsUuids: [item.Uuid],
    OnlyItemsWithEvents: true,
    eventsFilters: { isEvent: true },
  };

  return (
    <div>
      <Button
        variant=""
        onClick={handleShow}
        className="fw-bold text-white badge bg-secondary"
      >
        {label}
      </Button>

      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{ width: "800px" }}
        size="xl"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {isEventLocations
              ? "Map of Event Locations"
              : "Map of Assets Related to Event"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <AbsoluteLoadingIndicator loading={loading} />
          <MyMap>
            <div className="d-flex justify-content-start">
              <Clusters filters={filters} setLoading={setLoading} hideEvents />
            </div>
          </MyMap>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}
